import BaseModel from './BaseModel';
import { asyncFn } from './utils';

class OrderModel extends BaseModel {
  initialState = {
    all: {
      error: false,
      errorMessage: '',
      isLoading: false,
      data: [],
      headers: [],
      total: undefined,
    },
    stat: {
      error: false,
      errorMessage: '',
      isLoading: false,
      data: [],
      headers: [],
      total: undefined,
    },
    current: {
      error: false,
      errorMessage: '',
      isLoading: true,
      data: {},
    },
  }

  constructor(data = {}) {
    super(data);
    if (data.model) {
      this.model = {
        get: {
          request: this.buildActionName('request', data.model, 'get'),
          response: this.buildActionName('response', data.model, 'get'),
          error: this.buildActionName('error', data.model, 'get'),
        },
        create: {
          request: this.buildActionName('request', data.model, 'create'),
          response: this.buildActionName('response', data.model, 'create'),
          error: this.buildActionName('error', data.model, 'create'),
        },
        update: {
          request: this.buildActionName('request', data.model, 'update'),
          response: this.buildActionName('response', data.model, 'update'),
          error: this.buildActionName('error', data.model, 'update'),
        },
        delete: {
          request: this.buildActionName('request', data.model, 'delete'),
          response: this.buildActionName('response', data.model, 'delete'),
          error: this.buildActionName('error', data.model, 'delete'),
        },
        all: {
          request: this.buildActionName('request', data.model, 'all'),
          response: this.buildActionName('response', data.model, 'all'),
          error: this.buildActionName('error', data.model, 'all'),
        },
        stat: {
          request: this.buildActionName('request', data.model, 'stat'),
          response: this.buildActionName('response', data.model, 'stat'),
          error: this.buildActionName('error', data.model, 'stat'),
        },
      };
    }
  }

  get = ({ body }) => asyncFn({
    body, url: `${this.url}/get`, model: this.model.get,
  })
  create = ({ body }) => asyncFn({
    body, url: `${this.url}/create`, model: this.model.create,
  })
  update = ({ body }) => asyncFn({
    body, url: `${this.url}/update`, model: this.model.update,
  })
  delete = ({ body }) => asyncFn({
    body, url: `${this.url}/remove`, model: this.model.delete,
  })
  all = ({ body } = {}) => asyncFn({
    body, url: `${this.url}/list`, model: this.model.all,
  })
  stat = ({ body } = {}) => asyncFn({
    body, url: `${this.url}/stat`, model: this.model.stat,
  })


  reset = () => async (dispatch) => {
    dispatch({
      type: 'FORM_RESET',
    });
  };

  reducer = (state = this.initialState, action) => {
    switch (action.type) {
      case 'FORM_RESET':
        console.log('action: ', action);
        return {
          ...state,
          current: {
            error: false,
            errorMessage: '',
            isLoading: false,
            data: {},
          },
        };
      case this.model.all.request:
        return {
          ...state,
          all: this.requestCase(state.all, action),
        };
      case this.model.all.error:
        return {
          ...state,
          all: this.errorCase(state.all, action),
        };
      case this.model.all.response:
        return {
          ...state,
          all: {
            ...state.all,
            isLoading: false,
            data: action.payload.list,
            total: action.payload.total,
          },
        };
      case this.model.stat.request:
        return {
          ...state,
          stat: this.requestCase(state.stat, action),
        };
      case this.model.stat.error:
        return {
          ...state,
          stat: this.errorCase(state.stat, action),
        };
      case this.model.stat.response:
        return {
          ...state,
          stat: {
            ...state.stat,
            isLoading: false,
            data: action.payload,
            total: action.payload.total,
          },
        };
      case this.model.get.request:
        return {
          ...state,
          current: this.requestCase(state.current, action),
        };
      case this.model.get.error:
        return {
          ...state,
          current: this.errorCase(state.current, action),
        };
      case this.model.get.response:
        return {
          ...state,
          current: {
            ...state.current,
            isLoading: false,
            data: action.payload,
          },
        };
      case this.model.create.request:
        return {
          ...state,
          current: this.requestCase(state.current, action),
        };
      case this.model.create.error:
        return {
          ...state,
          current: this.errorCase(state.current, action),
        };
      case this.model.create.response:
        return {
          ...state,
          current: {
            ...state.current,
            isLoading: false,
            data: action.payload,
          },
        };
      case this.model.update.request:
        return {
          ...state,
          current: this.requestCase(state.current, action),
        };
      case this.model.update.error:
        return {
          ...state,
          current: this.errorCase(state.current, action),
        };
      case this.model.update.response:
        return {
          ...state,
          current: {
            ...state.current,
            isLoading: false,
            data: typeof action.payload === 'object' ? action.payload : {},
          },
        };
      case this.model.delete.request:
        return {
          ...state,
          current: this.requestCase(state.current, action),
        };
      case this.model.delete.error:
        return {
          ...state,
          current: this.errorCase(state.current, action),
        };
      case this.model.delete.response:
        return {
          ...state,
          current: {
            ...state.current,
            isLoading: false,
            data: {},
          },
        };
      default:
        return state;
    }
  }
}

export default OrderModel;



// WEBPACK FOOTER //
// ./src/models/OrderModel.js